import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="text-red-500">Fresh Chicken – Chełmno</span>{' '}
          <span className="text-3xl">🌯🔥</span>
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed">
          <p>
            Znajdujemy się w samym sercu Chełmna – na rynku, gdzie{' '}
            <span className="text-red-500 font-semibold">od ponad 12 lat</span>{' '}
            serwujemy dla Was najlepsze smaki 🍴
          </p>

          <p>
            Jesteśmy{' '}
            <span className="text-red-500 font-semibold">
              najstarszą restauracją typu fast food w mieście
            </span>
            , a nasze doświadczenie przekładamy na jakość, którą czuć w każdym kęsie 💪
          </p>

          <p>
            Specjalizujemy się w przygotowywaniu{' '}
            <span className="text-red-500 font-semibold">
              świeżych, soczystych kebabów
            </span>
            , które każdego dnia podbijają podniebienia naszych klientów 🤤
          </p>

          <p>
            Jeśli szukasz miejsca, gdzie zjesz{' '}
            <span className="text-red-500 font-semibold">
              jednego z najlepszych kebabów w regionie
            </span>{' '}
            – nie mogłeś trafić lepiej 🙌
          </p>

          <p className="text-2xl font-bold text-red-500 pt-4">
            👉 Wpadnij do nas i przekonaj się sam!
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
